export default {"src":"/_next/static/media/7.19329d12.svg","height":130,"width":116,"blurWidth":0,"blurHeight":0};